import { FC, useEffect, useState } from 'react';
import { IConnectBakery2bClientWithCustomer } from './connectBakery2bClientWithCustomer.popup.tsx';
import { PopupService } from '../../../../../../../shared/components/popup/services/popup.service.ts';
import { useTranslation } from 'react-i18next';
import { Button, Stack, Alert } from '@mui/material';
import { FormTextField } from '../../../../../../../shared/components/form/index.ts';
import { createValidationSchema } from './connectBakery2bClientWithCustomer.schema.ts';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { bakery2bTabState } from '../../bakery2b.state.ts';
import { AlternateEmail } from '@mui/icons-material';
import { IShortAccountInfo } from './connectBakery2bClientWithCustomer.popup.tsx';

const validationSchema = createValidationSchema();
export const Content: FC<IContent> = ({ stream }) => {
  const [t] = useTranslation();
  const [isCreatredAcc, setIsCreatredAcc] = useState(false);
  const [isAlreadyAddedAcc, setIsAlreadyAddedAcc] = useState(false);
  const [alreadyCreatredBakery2bAccs, setAlreadyCreatredBakery2bAccs] = useState<
    IShortAccountInfo[]
  >([]);
  const [alreadyAddedBakery2bAccs, setAlreadyAddedBakery2bAccs] = useState<string[]>([]);
  const [customerId, setCustomerId] = useState<string>('');
  const formMethods = useForm({
    mode: 'onSubmit',
    defaultValues: {
      name: null,
      email: null,
    },
    resolver: yupResolver(validationSchema),
  });
  const errors = formMethods.formState.errors;

  useEffect(() => {
    stream.actionListener('open').subscribe((data) => {
      setAlreadyCreatredBakery2bAccs(data.alreadyCreatredBakery2bAccs);
      setAlreadyAddedBakery2bAccs(data.alreadyAddedBakery2bAccs);
      setCustomerId(data.customerId);
    });
  }, []);

  const handleSubmit = () => {
    bakery2bTabState.pub.addRecord({
      customerId: customerId,
      email: formMethods.getValues().email,
      name: formMethods.getValues().name,
    });
    stream.emit('close');
  };

  return (
    <Stack width='500px' p={3}>
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(handleSubmit)} noValidate>
          <Stack direction={'column'} spacing={3}>
            <FormTextField
              name='email'
              label={t('common.email')}
              width='100%'
              InputProps={{
                endAdornment: <AlternateEmail sx={{ color: 'rgba(0, 0, 0, 0.54)' }} />,
              }}
              onChange={(v) => {
                const createdAcc = alreadyCreatredBakery2bAccs.find(
                  (item) => item.email.toLowerCase() === v.toLowerCase(),
                );
                const alreadyAddedAcc = alreadyAddedBakery2bAccs.find(
                  (item) => item.toLowerCase() === v.toLowerCase(),
                );

                setIsAlreadyAddedAcc(!!alreadyAddedAcc);
                setIsCreatredAcc(!!createdAcc);

                if (createdAcc && !alreadyAddedAcc) {
                  formMethods.setValue('name', createdAcc.name);
                  formMethods.clearErrors('name');
                }
              }}
              {...(errors.email && {
                error: true,
                helperText: t(errors.email.message as string),
              })}
            />

            <FormTextField
              inputProps={{ maxLength: 64 }}
              name='name'
              disabled={isCreatredAcc && !isAlreadyAddedAcc}
              label={t('common.name')}
              required
              width='100%'
              error={Boolean(errors['name'])}
            />

            {!isCreatredAcc && !isAlreadyAddedAcc && formMethods.watch('email') && (
              <Alert severity='info'>
                {t('customer.invitation_will_be_sent_to_email', {
                  email: formMethods.watch('email'),
                })}
              </Alert>
            )}

            {isCreatredAcc && !isAlreadyAddedAcc && formMethods.watch('email') && (
              <Alert severity='info'>
                {t('customer.account_for_email_already_registred_with_name', {
                  email: formMethods.watch('email'),
                  name: formMethods.watch('name'),
                })}
              </Alert>
            )}

            {isAlreadyAddedAcc && formMethods.watch('email') && (
              <Alert severity='error'>
                {t('customer.an_account_has_already_been_added_for_this_customer')}
              </Alert>
            )}
          </Stack>
          <Stack
            direction='row'
            justifyContent='flex-end'
            mt={formMethods.watch('email') ? 1 : 10}
            pt={1}
          >
            <Button
              variant='contained'
              sx={{ minWidth: '125px' }}
              type='submit'
              disabled={isAlreadyAddedAcc}
            >
              {t('common.save')}
            </Button>
          </Stack>
        </form>
      </FormProvider>
    </Stack>
  );
};

export interface IContent {
  stream: PopupService<IConnectBakery2bClientWithCustomer>;
}
